import { noop } from "lodash";

import type { RootRouteContext } from "@/react/tanstack_routes/__root";

// Shared by the `lazyWithRetry` call sites and the route loaders so a router
// preload resolves to the same chunk the page renders.
export const loadMobileFeedContent = () =>
  import(
    /* webpackChunkName: "MobileFeedContent" */ "@/react/components/Mobile/pages/FeedContent"
  );

export const loadMobileNotificationsContent = () =>
  import(
    /* webpackChunkName: "MobileNotificationsContent" */ "@/react/components/Mobile/pages/NotificationsContent"
  );

export const loadMobileMessagesContent = () =>
  import(
    /* webpackChunkName: "MobileMessagesContent" */ "@/react/components/Mobile/pages/MessagesContent"
  );

export const loadMobileCoursesContent = () =>
  import(
    /* webpackChunkName: "MobileCoursesContent" */ "@/react/components/Mobile/pages/CoursesContent"
  );

export const loadMobileEventsContent = () =>
  import(
    /* webpackChunkName: "MobileEventsContent" */ "@/react/components/Mobile/pages/EventsContent"
  );

export const loadMobileLeaderboardContent = () =>
  import(
    /* webpackChunkName: "MobileLeaderboardContent" */ "@/react/components/Mobile/pages/LeaderboardContent"
  );

export const loadMobileMembersContent = () =>
  import(
    /* webpackChunkName: "MobileMembersContent" */ "@/react/components/Mobile/pages/MembersContent"
  );

// Chunk name kept as it was before these loaders existed.
export const loadMobileBookmarksContent = () =>
  import(
    /* webpackChunkName: "BookmarksContentMobile" */ "@/react/components/Mobile/pages/BookmarksContent"
  );

/**
 * Route `loader` that starts downloading a mobile page chunk, so a router
 * preload warms it and a real navigation fetches it before the page suspends.
 * Not awaited: the page's Suspense fallback covers a slow download, and
 * `lazyWithRetry` handles failures on render.
 */
export const preloadMobilePage =
  (load: () => Promise<unknown>) =>
  ({ context }: { context: RootRouteContext }) => {
    if (context.isMobile) void load().catch(noop);
  };
